import { ref } from 'vue';
import { defineStore } from 'pinia';
import { useUserStore } from '@/stores/userStore';

export const useDemoFavoritesStore = defineStore('demo-favorites', () => {
  const userStore = useUserStore();
  const toastVisible = ref(false);
  const TOAST_DURATION_MS = 5000;
  let hideTimer = null;

  // The page-level flag can be missing, so also honor the demo flag from user details.
  function isDemoAccount() {
    return window.appConfig?.isDemo001Account === true || userStore.userDetails?.IsDemoAccount === true;
  }

  // Returns true when the demo account is blocked from changing favorites, and shows the toast.
  function blockIfDemo() {
    if (!isDemoAccount()) return false;
    toastVisible.value = true;
    clearTimeout(hideTimer);
    hideTimer = setTimeout(hideToast, TOAST_DURATION_MS);
    return true;
  }

  function hideToast() {
    clearTimeout(hideTimer);
    toastVisible.value = false;
  }

  return { toastVisible, blockIfDemo, hideToast };
});
